import React from "react";
import PostPreview from "./PostPreview";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";

function Posts( props ) {
    // const posts = [];
    // db.collection("blogs").get().then(snapshot => {
    //     snapshot.docs.forEach(doc => {
    //         posts.push(doc.data());
    //     })
    // });
    const blogsRef = db.collection("blogs");
    const query = blogsRef.orderBy('title').limit(25);
    const [posts, loading, error] = useCollectionData(query, {idField: "id"});
    return (
        <section className="col" id="PostListContainer">
            <h2>Latest Posts</h2>
            <div className="container-fluid ps-0 p-0">
                {loading && <h1>Loading...</h1>}
                {error && <h1>{error}</h1>}
                {posts && posts.map(post => (
                    <PostPreview 
                        key={post.id}
                        title={post.title}
                        description={post.description}
                        featuredImg={post.featuredImg}
                        createdAt={post.createdAt}
                        author={post.author}
                        docId={post.id}
                        username={props.username}
                    />
                ))
                }
            </div>
        </section>
    );
}

export default Posts;